'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var context = require('@stickyroll/context');
var frame = require('@stickyroll/frame');

class Stickyroll extends frame.Frame {
}

Object.keys(context).forEach(function (k) {
	if (k !== 'default') Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () {
			return context[k];
		}
	});
});
Object.keys(frame).forEach(function (k) {
	if (k !== 'default') Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () {
			return frame[k];
		}
	});
});
Object.defineProperty(exports, 'Listener', {
	enumerable: true,
	get: function () {
		return context.ScrollConsumer;
	}
});
exports.Stickyroll = Stickyroll;
